import React from "react";
import styled from "styled-components";

const AboutContainer = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  font-family: "Arial", sans-serif;
  color: white; /* Set text color to white for visibility */
`;

const Heading = styled.h1`
  font-size: 2.5em;
  margin-bottom: 20px;
`;

const Paragraph = styled.p`
  line-height: 1.6;
  margin-bottom: 15px;
`;

function About() {
  return (
    <AboutContainer>
      <Heading>About Me</Heading>
      <Paragraph>
        Hi, I’m Marcha, a creative technologist specializing in product development. 
        My work explores the intersection of storytelling, technology, and human-centered design. 
        I’ve contributed to projects ranging from editorial storytelling to AI research and prototyping. 
      </Paragraph>
      <Paragraph>
        I believe in using design and technology to create meaningful, impactful experiences. 
        Whether it's prototyping innovative solutions, designing intuitive interfaces, or conducting user research, 
        my goal is to bridge the gap between human needs and technical possibilities.
      </Paragraph>
      <Paragraph>
        When I’m not working, I enjoy running, making music and exploring the capabilities of generative AI in spatial contexts. My forever obsession will always be uncovering the role emotionally intelligent algorithms may play in shaping the future of human centered design.
      </Paragraph>
      <Paragraph>
        I welcome collaborators. If you'd like to connect, don't hesitate to contact me.
      </Paragraph>
    </AboutContainer>
  );
}

export default About;
